/* import __COLOCATED_TEMPLATE__ from './metric-stamp.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import type { JobGroupObject } from 'embercom/components/reporting/automation/ai-insights/fin-insights/jobs';
import type { ReportState } from 'embercom/components/reporting/custom/report/chart-card';
import { staticDataResource } from 'embercom/lib/reporting/static-data-resource';
import { use } from 'ember-resources/util/function-resource';

interface Signature {
  Args: {
    jobGroupObject: JobGroupObject;
    reportState: ReportState;
  };
}

export default class MetricStamp extends Component<Signature> {
  @use dataResource = staticDataResource(this, {
    serializedChart: () => this.countChartDefinition,
    reportState: () => this.args.reportState,
  });

  get countChartDefinition() {
    return {
      visualization_type: 'counter',
      view_by: null,
      chart_series: [
        {
          metric_id: this.args.jobGroupObject.metric,
          aggregation: undefined,
        },
      ],
    };
  }

  get countValue() {
    return this.dataResource.formatValue(
      this.dataResource.kpiData[0],
      this.args.jobGroupObject.metric,
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::FinInsights::MetricStamp': typeof MetricStamp;
  }
}
